<mat-drawer-container fullscreen style="background-color: transparent;">
    <mat-drawer #sidenav mode="over" position="end">
        <a class="close-icon" (click)="close()">
            <div class="line1">
                <div class="line2"></div>
            </div>
        </a>
        <ul class="usermenu">
            @if (user()==null && isAdmin()==false) {
            <li class="blue"><a href="mailto:info@kilowant.com?subject=Kilowant Contact" class="fb mt-50"><b>Contact Us</b></a></li>
            <li class="mt-2"><a (click)="goto('/user/kilowant-u')" class="yellow"><b>kilowant U</b></a></li>
            <li class="mt-2"><a (click)="goto('/our-story')"><b>Our Story</b></a></li>
            <li class="mt-2"><a (click)="goto('/faq')"><b>FAQ</b></a></li>
            <li class="mt-2"><a (click)="goto('/user/registration')"><b>Sign Up</b></a></li>
            <li class="mt-2"><a (click)="goto('/user/login')"><b>Sign In</b></a></li>
            }
            @if (user()!=null && isAdmin()==false && isSupplier()==false) {
            <li class="blue"><a href="mailto:info@kilowant.com?subject=Kilowant Contact" class="fb mt-50"><b>Contact Us</b></a></li>
            @if (hasAccount()) {
            <li class="mt-2"><a (click)="goto('/user/faq')"><b>FAQs</b></a></li>
            }
            <li class="mt-2"><a (click)="goto('/user/kilowant-u')" class="yellow"><b>kilowant U</b></a></li>
            @if (hasAccount()) {
            <li class="mt-2"><a (click)="goto('/user/home')"><b>My kilowant</b></a></li>
            }
            @if (user()!=null && !user()!.isPreRegister) {
            <li class="mt-2"><a (click)="goto('/ai-task/list')"><b>AI Tasks</b></a></li>
            }
            @if (user()!=null && user()!.isAdvisor) {
            <li class="mt-2"><a (click)="goto('/client/list')"><b>Clients</b></a></li>
            <li class="mb-2"><a (click)="goto('/client/add')">Add</a></li>
            }
            <li class="mt-2"><a (click)="goto('/account/list')"><b>Accounts</b></a></li>
            <li class="mb-2"><a (click)="goto('/account/add')">Add</a></li>
            @if (hasAccount()) {
            <li><a (click)="goto('/priceplans/list')"><b>Price Plans</b></a></li>
            }
            @if (hasAccount()) {
            <li class="mb-2"><a (click)="goto('/priceplans/details')">Add</a></li>
            }
            @if (user()!=null && !user()!.isPreRegister) {
            <li class="mt-4"><a (click)="goto('/user/details')"><b>Settings</b></a></li>
            }
            <li><a (click)="goto('/user/logout')"><b>Sign Out</b></a></li>
            }
            @if (user()!=null && isAdmin()==false && isSupplier()==true) {
            <li class="blue"><a href="mailto:info@kilowant.com?subject=Kilowant Contact" class="fb mt-50"><b>Contact Us</b></a></li>
            <li class="mt-50"><a (click)="goto('/seller/home')"><b>My kilowant</b></a></li>
            <li class="mt-20"><a (click)="goto('/seller/company/utilities')"><b>Utilities</b></a></li>
            <li class="mb-20"><a (click)="goto('/seller/company/utilities/add')">Add</a></li>
            <li><a (click)="goto('/seller/terms')"><b>Sales Agreements</b></a></li>
            <li><a (click)="goto('/seller/terms/add')">Add</a></li>
            <li class="mt-20"><a (click)="goto('/seller/fees')"><b>Licensing Fees</b></a></li>
            <li class="mt-20"><a (click)="goto('/seller/batch-export')"><b>Batch Export</b></a></li>
            <li class="mt-50 mb-20"><a (click)="goto('/seller/my-account')"><b>Settings</b></a></li>
            <li><a (click)="goto('/user/logout')"><b>Sign Out</b></a></li>
            }
            @if (isAdmin()==true) {
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/waitlist')"><b>Waitlist</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/sellers')"><b>Sellers</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/buyers')"><b>Buyers</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/affiliates')"><b>Affiliates</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/admin-users')"><b>Admins</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/unverified-users')"><b>Unverified Users</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/utilities')"><b>Utilities</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/fees')"><b>Fees</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/consumption')"><b>Consumption</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/faqs')"><b>FAQ</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/chart')"><b>Chart</b></a></li>
            <li class="mt-2"><a (click)="goto('/admin-kilowant-area/home/export')"><b>Export</b></a></li>
            <li class="mt-20"><a (click)="goto('/admin-kilowant-area/user/logout')"><b>Sign Out</b></a></li>
            }
        </ul>
    </mat-drawer>
    @if (initLoaded()) {
    <mat-drawer-content #pageContent style="overflow-x: hidden">
        <div class="content">
            <router-outlet></router-outlet>
        </div>
        <kilowant-footer></kilowant-footer>
        <kilowant-loader></kilowant-loader>
    </mat-drawer-content>
    }
</mat-drawer-container>
